import React, { useEffect, useState } from 'react'
import moment from 'moment';
import styles from './Titles.module.css'


const Titles = (props: any) => {

    const [pendingList, setPendingList] = useState<any>([])
    const [completedList, setCompletedList] = useState<any>([])
    const [isLoaded, setIsLoaded] = useState(false)

    useEffect(() => {
        let pendingList:any = []
        let completedList:any = []
        props.todos && props.todos.length > 0 && props.todos.map((item: any) => {
            // If Item is completed push the complete object
            if(item.completed) {
                completedList.push(item)
            } else {
                pendingList.push(item)
            }
        })
        setCompletedList(completedList)
        setPendingList(pendingList)
        setIsLoaded(true)
    }, [])

    const switchTab = (title: string) => {
        props.setSelectedType(title)
        if(title === 'pending') {
            props.getSelectedItem(pendingList[0].id)
        } else if(title === 'completed') {
            props.getSelectedItem(completedList[0].id)
        }
    }

    const pendingItems = pendingList && pendingList.length > 0 && pendingList.map((item: any, index: number) => {
        let dueDate = moment(item.dueDate).fromNow()
        let isExpired = dueDate.includes('ago')
        return  <button key={item.id} onClick={() => props.getSelectedItem(item.id)} className={`${styles.tabContentTitle} ${props.selectedId === item.id && styles.active}`}>
                    <span>{item.title}</span>
                    <span className={`${styles.dueDate} ${isExpired && styles.expired}`}><i className={`${styles.clock} pe-1 bi bi-clock`}></i>{dueDate}</span>
                </button>
    })

    const completedItems = completedList && completedList.length > 0 && completedList.map((item: any) => {
        return  <button key={item.id} onClick={() => props.getSelectedItem(item.id)} className={`${styles.tabContentTitle} ${props.selectedId === item.id && styles.active}`}>
                    {item.title}
                </button>
    })

    return (
        <div className={styles.navTabContainer}>
            <ul className={`nav nav-pills mb-3 ${styles.navPills} p-1`} id="pills-tab" role="tablist">
                <li className="nav-item" role="presentation">
                    <button onClick={() => switchTab('pending')} className={`nav-link ${props.selectedType === 'pending' && styles.active}`} id="pills-pending-tab" data-bs-toggle="pill" data-bs-target="#pills-pending" type="button" role="tab" aria-controls="pills-pending" aria-selected="true">Pending (15)</button>
                </li>
                <li className="nav-item" role="presentation">
                    <button onClick={() => switchTab('completed')} className={`nav-link ${props.selectedType === 'completed' && styles.active}`} id="pills-completed-tab" data-bs-toggle="pill" data-bs-target="#pills-completed" type="button" role="tab" aria-controls="pills-completed" aria-selected="false">Completed (5)</button>
                </li>
            </ul>
            {
                isLoaded &&
                <div className={`tab-content ${styles.tabContent}`} id="pills-tabContent">
                    <div className={`tab-pane fade ${props.selectedType === 'pending' && 'active show'}`} id="pills-pending" role="tabpanel" aria-labelledby="pills-pending-tab">
                        {pendingItems}
                    </div>
                    <div className={`tab-pane fade ${props.selectedType === 'completed' && 'active'}`} id="pills-completed" role="tabpanel" aria-labelledby="pills-completed-tab">
                        {completedItems}
                    </div>
                </div>
            }
        </div>
    )
}

export default Titles
